export interface UserProfile {
    username: string;
    photo: string; // base64 string
    selectedLanguage?: string; // Optional language selection (e.g., "Batak Toba")
    avatarBg?: string; // Optional avatar background color
}

export interface UserProgress {
    aksaraCompleted: string[];
    achievements: string[];
    coursesCompleted: string[]; // Keep for backward compatibility
    lessonProgress: { [lessonId: string]: number }; // New: tracks completion count (0-5) for each lesson
}

export interface UserMeta {
    money: number;
    heart: number;
    streak: {
        current: number;
        lastLoginDate: string; // ISO date string
    };
    xp: number;
    level: number;
    heartRecovery: {
        lastRecoveryTime: string; // ISO timestamp of last heart recovery
        nextRecoveryTime?: string; // ISO timestamp when next heart will be available
    };
    darkMode?: boolean; // Persist dark mode preference
}

export interface UserData {
    profile: UserProfile;
    progress: UserProgress;
    meta: UserMeta;
}

export const DEFAULT_PROGRESS: UserProgress = {
    aksaraCompleted: [],
    achievements: [],
    coursesCompleted: [],
    lessonProgress: {}, // New field for tracking lesson completion counts
};

export const DEFAULT_META: UserMeta = {
    money: 1000,
    heart: 5, // Start with 5 hearts
    streak: {
        current: 0,
        lastLoginDate: new Date().toISOString().split('T')[0], // Today's date in YYYY-MM-DD format
    },
    xp: 0,
    level: 1,
    heartRecovery: {
        lastRecoveryTime: new Date().toISOString(), // Current time
    },
    darkMode: false,
};
